import { forwardRef } from "react";

import { SxProps, Theme, Box } from "@mui/material";

import { DashboardIcon, DashboardIconProps } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardTooltip, DashboardTooltipProps } from "@/dashboard-design-system/Tooltip/DashboardTooltip";
import { mergeSx } from "@/helpers/mergeSx";
import { Info as InfoIcon } from "@/icons/outlined";

export type DashboardInformationTooltipProps = Omit<DashboardTooltipProps, "children" | "disabled"> & {
  alignOnText?: boolean;
  alignOffset?: string;
  slotProps?: DashboardTooltipProps["slotProps"] & {
    icon?: Omit<DashboardIconProps, "ref" | "children">;
  };
  sx?: SxProps<Theme>;
};

export const DashboardInformationTooltip = forwardRef<HTMLDivElement, DashboardInformationTooltipProps>(
  ({ alignOnText = false, alignOffset, slotProps, sx, ...rest }, ref) => {
    const { icon: iconProps, ...tooltipProps } = slotProps ?? {};

    const styles = mergeSx(
      {
        display: "inline-flex",
        cursor: "help",
        ...(alignOnText && {
          position: "relative",
          top: alignOffset || "0.25rem",
        }),
      },
      sx
    );

    return (
      <Box sx={styles}>
        <DashboardTooltip {...rest} ref={ref} slotProps={tooltipProps}>
          <DashboardIcon vibe="text-neutral-supershy" size="small" {...(iconProps ?? {})}>
            <InfoIcon />
          </DashboardIcon>
        </DashboardTooltip>
      </Box>
    );
  }
);

DashboardInformationTooltip.displayName = "DashboardInformationTooltip";
